import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=3e1f33d3&scoped=true&"
import script from "./SideBar.js?vue&type=script&lang=js&"
export * from "./SideBar.js?vue&type=script&lang=js&"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=3e1f33d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1f33d3",
  null
  
)

export default component.exports